import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AffirmationOfTheDay } from "@/components/AffirmationOfTheDay";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
      {/* Floating Affirmation Button - appears on all pages */}
      <AffirmationOfTheDay variant="modal" />
    </div>
  );
};
